/* eslint-disable max-lines */
/* eslint-disable sonarjs/no-duplicate-string */
import { getStaticFilePath } from '@tcp/core/src/utils/utils';
import orange from '@tcp/core/styles/themes/colors/orange';
import blue from '@tcp/core/styles/themes/colors/blue';
import purple from '@tcp/core/styles/themes/colors/purple';
import black from '@tcp/core/styles/themes/colors/common';
import pjpColorsTheme from '@tcp/core/styles/themes/PJP';
import { TCP, TCP_CMS, GYM, GYM_CMS, SNJ, SNJ_CMS, PJP, PJP_CMS } from './brands.constants';
import { BRAND_CONFIG_OPTION, IMAGES_BADGE_PARAMS_PATH } from './brandSpecific.server.constants';
import { HEADER_STYLES, SUB_HEADER_STYLES } from './banner404brandStyle.constants';

const LONGER_BRAND_IDS = {
  [TCP]: 'tcp',
  [GYM]: 'gymboree',
  [SNJ]: 'snj',
  [PJP]: 'pjp',
};

const BRAND_TOKEN = {
  [TCP]: 'token=tcprwd',
  [GYM]: 'token=gymrwd',
  [SNJ]: 'token=rwdsnj2021',
  [PJP]: 'token=rwdpjp2022',
};

const BODY_COLOR = {
  [TCP]: 'red.500',
  [GYM]: 'gray.900',
  [SNJ]: 'red.500',
  [PJP]: 'red.500', // PJP To-Do
};

const BRAND_CMS = {
  [TCP]: TCP_CMS,
  [GYM]: GYM_CMS,
  [SNJ]: SNJ_CMS,
  [PJP]: PJP_CMS,
};

const CANDID_TAG = {
  [TCP]: 'gallery',
  [GYM]: 'gymboree-hp',
  [SNJ]: 'gallery',
  [PJP]: 'gallery', // PJP To-Do
};

const BIG_CARROT_ICON = 'carousel-big-carrot';

const CAROUSAL_ICON = {
  [TCP]: BIG_CARROT_ICON,
  [GYM]: BIG_CARROT_ICON,
  [SNJ]: BIG_CARROT_ICON,
  [PJP]: BIG_CARROT_ICON,
};

const CATEGORY_CAROUSEL_IMAGE = {
  [TCP]: {
    HEIGHT: 60,
    WIDTH: 95,
    URL: '/ecom/assets/content/tcp/us/app/clearance_4_.jpg',
    BORDER_RADIUS: 'initial',
  },
  [GYM]: {
    HEIGHT: 76,
    WIDTH: 76,
    URL: '/ecom/assets/content/tcp/us/app/clearance_circular.png',
    BORDER_RADIUS: 76,
  },
  [SNJ]: {
    HEIGHT: 60,
    WIDTH: 95,
    URL: '/ecom/assets/content/tcp/us/app/clearance_4_.jpg',
    BORDER_RADIUS: 'initial',
  },
  // PJP To-Do
  [PJP]: {
    HEIGHT: 60,
    WIDTH: 95,
    URL: 'ecom/assets/content/tcp/us/app/clearance_circular.png',
    BORDER_RADIUS: 'initial',
  },
};

const COLOR_VARIATION = {
  [TCP]: 'LIGHTBLUE',
  [GYM]: 'ORANGE',
  [SNJ]: 'PURPLE',
  [PJP]: 'PURPLE', // PJP To-Do
};

const COLOR_VARIATION_PLP = {
  [TCP]: 'BLUE',
  [GYM]: 'ORANGE',
  [SNJ]: 'PURPLE',
  [PJP]: 'PURPLE', // PJP To-Do
};

const DOMAIN = {
  [TCP]: '.childrensplace.com',
  [GYM]: '.gymboree.com',
  [SNJ]: '.sugarandjade.com', // BRAND-SPECIFIC-TODO
  [PJP]: '.pjplace.com',
};

const DOWNLOAD_APP_CLICK_EVENT_DATA = {
  [TCP]: ['event170'],
  [GYM]: ['event171'],
  [SNJ]: ['event173'],
  [PJP]: ['event170'], // PJP To-Do
};

const FOOTER_CANDIDATE_A_COL_SIZE = {
  [TCP]: {
    MEDIUM: 4,
  },
  [GYM]: {
    MEDIUM: 8,
  },
  [SNJ]: {
    MEDIUM: 4,
  },
  // PJP To-Do
  [PJP]: {
    MEDIUM: 4,
  },
};

const FOOTER_CANDIDATE_A_REFER_FRIEND_COL_SIZE = {
  [TCP]: {
    MEDIUM: 4,
  },
  [GYM]: {
    MEDIUM: 0,
  },
  [SNJ]: {
    MEDIUM: 4,
  },
  // PJP To-Do
  [PJP]: {
    MEDIUM: 4,
  },
};

const FOOTER_CANDIDATE_B_COL_SIZE = {
  [TCP]: {
    LARGE: 3,
  },
  [GYM]: {
    LARGE: 4,
  },
  [SNJ]: {
    LARGE: 3,
  },
  // PJP To-Do
  [PJP]: {
    LARGE: 3,
  },
};

const FOOTER_CANDIDATE_B_SOCIAL_MEDIA_COL_SIZE = {
  [TCP]: {
    LARGE: 3,
    MEDIUM: 4,
  },
  [GYM]: {
    LARGE: 4,
    MEDIUM: 8,
  },
  // PJP To-Do
  [PJP]: {
    LARGE: 4,
    MEDIUM: 8,
  },
};

const HEADER_GRAY_ICON = {
  [TCP]: false,
  [GYM]: true,
  [SNJ]: true,
  [PJP]: true, // PJP To-Do
};
const ICON_FILL_COLOR = {
  [TCP]: blue[500],
  [GYM]: orange[500],
  [SNJ]: black[50],
  [PJP]: black[50], // PJP To-Do
};
const SNJ_PRIMARY_FILL_BLUE = {
  [TCP]: 'BLUE',
  [GYM]: 'BLUE',
  [SNJ]: 'SNJ_PRIMARY',
  [PJP]: 'BLUE', // PJP To-Do
};
const SNJ_SECONDARY_FILL_WHITE = {
  [TCP]: 'WHITE',
  [GYM]: 'WHITE',
  [SNJ]: 'SNJ_SECONDARY',
  [PJP]: 'PJP_PRIMARY',
};
const SNJ_HP_PRIMARY_FILL = {
  [TCP]: 'WHITE',
  [GYM]: 'WHITE',
  [SNJ]: 'SNJ_HP_PRIMARY',
  [PJP]: 'BLUE', // PJP To-Do
};

const GET_CANDID_WALL_PLUGIN_CLASS = {
  [TCP]: '',
  [GYM]: 'button-gymboree',
  [SNJ]: '',
  [PJP]: '', // PJP To-Do
};

const GUIDE_COLOR = {
  [TCP]: blue.B100,
  [GYM]: orange[800],
  [SNJ]: purple[800],
  [PJP]: purple[800], // PJP To-Do
};

const LINK_TEXT_STYLE = {
  [TCP]: {
    COLOR: 'text.primary',
    FONT_FAMILY: 'secondary',
    LINE_HEIGHT: 50,
  },
  [GYM]: {
    COLOR: 'white',
    FONT_FAMILY: 'primary',
    LINE_HEIGHT: 47,
  },
  [SNJ_CMS]: {
    COLOR: 'text.primary',
    FONT_FAMILY: 'secondary',
    LINE_HEIGHT: 50,
  },
  // PJP To-Do
  [PJP_CMS]: {
    COLOR: 'text.secondary',
    FONT_FAMILY: 'secondary',
    LINE_HEIGHT: 50,
  },
};

const MODULE_A = {
  [TCP]: {
    IMAGE_CONFIG: ['t_mod_A_img_m', 't_mod_A_img_t', 't_mod_A_img_d'],
    LINK_TEXT_COLOR: '',
    MODULE_HEIGHT: 412,
    LINK_TEXT_SINGLE_IMAGE_CLASS: 'single-image-header',
    RENDER_CLASSNAME: 'tcp-module-a',
  },
  [GYM]: {
    IMAGE_CONFIG: ['t_mod_A_GYM_img_m', 't_mod_A_GYM_img_t', 't_mod_A_GYM_img_d'],
    LINK_TEXT_COLOR: 'white',
    MODULE_HEIGHT: 500,
    LINK_TEXT_SINGLE_IMAGE_CLASS: '',
    RENDER_CLASSNAME: 'gymboree-module-a',
  },
  [SNJ]: {
    IMAGE_CONFIG: ['t_mod_A_img_m', 't_mod_A_img_t', 't_mod_A_img_d'],
    LINK_TEXT_COLOR: '',
    MODULE_HEIGHT: 412,
    LINK_TEXT_SINGLE_IMAGE_CLASS: 'single-image-header',
    RENDER_CLASSNAME: 'tcp-module-a',
  },
  [PJP]: {
    IMAGE_CONFIG: ['t_mod_A_img_m', 't_mod_A_img_t', 't_mod_A_img_d'],
    LINK_TEXT_COLOR: '',
    MODULE_HEIGHT: 412,
    LINK_TEXT_SINGLE_IMAGE_CLASS: 'single-image',
    RENDER_CLASSNAME: 'tcp-module-a',
  },
};

const MODULE_D = {
  [TCP]: {
    FONT_FAMILY: 'tertiary',
  },
  [GYM]: {
    FONT_FAMILY: 'primary',
    LETTER_SPACING: 'ls167',
  },
  [SNJ]: {
    FONT_FAMILY: 'tertiary',
  },
  // PJP To-Do
  [PJP]: {
    FONT_FAMILY: 'tertiary',
  },
};

const MODULE_G = {
  [TCP]: {
    BORDER_BOTTOM_COLOR: 'initial',
    BORDER_BOTTOM_WIDTH: 'initial',
  },
  [GYM]: {
    BORDER_BOTTOM_COLOR: 'orange',
    BORDER_BOTTOM_WIDTH: 2,
  },
  [SNJ]: {
    BORDER_BOTTOM_COLOR: 'initial',
    BORDER_BOTTOM_WIDTH: 'initial',
  },
  // PJP To-Do
  [PJP]: {
    BORDER_BOTTOM_COLOR: 'initial',
    BORDER_BOTTOM_WIDTH: 'initial',
  },
};

const MODULE_N = {
  [TCP]: {
    IMAGE_CONFIG: ['t_mod_N_img_m', 't_mod_N_img_t', 't_mod_N_img_d'],
  },
  [GYM]: {
    IMAGE_CONFIG: ['t_mod_N_GYM_img_m', 't_mod_N_GYM_img_t', 't_mod_N_GYM_img_d'],
  },
  [SNJ]: {
    IMAGE_CONFIG: ['t_mod_N_img_m', 't_mod_N_img_t', 't_mod_N_img_d'],
  },
  // PJP To-Do
  [PJP]: {
    IMAGE_CONFIG: ['t_mod_N_img_m', 't_mod_N_img_t', 't_mod_N_img_d'],
  },
};

const PICKUP_SKU_SELECTION_BRAND_COLOR = {
  [TCP]: 'red.500',
  [GYM]: 'black',
  [SNJ]: 'red.500',
  [PJP]: 'red.500', // PJP To-Do
};

const PRODUCT_ADD_TO_BAG_SHOW_SIMILAR_LINK = {
  [TCP]: true,
  [GYM]: false,
  [SNJ]: true,
  [PJP]: true, // PJP To-Do
};

const PRODUCT_PRICE_BODY_COPY_COLOR = {
  [TCP]: 'red.500',
  [GYM]: 'gray.900',
  [SNJ]: 'red.500', // updated as part of bugfix from gray.900 to red.500
  [PJP]: 'red.500', // PJP To-Do
};

const TOGGLE_BRAND = {
  [TCP]: 'gym',
  [GYM]: 'tcp',
  [SNJ]: 'snj',
  [PJP]: 'pjp',
};

const TWITTER_SITE_TAG = {
  [TCP]: '@childrensplace',
  [GYM]: '@Gymboree',
  [SNJ]: '@sugarnjade', // BRAND-SPECIFIC-TODO
  [PJP]: '@pjplace', // PJP To-Do
};

const TWITTER_SITE_CARD_TYPE = {
  [TCP]: 'summary',
  [GYM]: 'summary',
  [SNJ]: 'summary',
  [PJP]: 'summary',
};

const SHOW_REFER_FRIEND = {
  [TCP]: true,
  [GYM]: true,
  [SNJ]: true,
  [PJP]: true, // PJP To-Do
};

const SHOW_SOCIAL_MEDIA_LINKS = {
  [TCP]: true,
  [GYM]: true,
  [SNJ]: true,
  [PJP]: true, // PJP To-Do
};

const SOCIAL_MEDIA_CLASS_NAME = {
  [TCP]: 'social-media-links',
  [GYM]: 'footer_top_candidate_a_social_links',
  [SNJ]: 'social-media-links',
  [PJP]: 'footer_top_candidate_a_social_links', // PJP To-Do
};

const SWITCH_BRAND = {
  [TCP]: 'gymboree',
  [GYM]: 'tcp',
  [SNJ]: 'gymboree',
  [PJP]: 'pjplace', // PJP To-Do
};

const APP_BRAND = {
  [GYM]: 'gymboree',
  [TCP]: 'tcp',
  [SNJ]: 'snj',
  [PJP]: 'pjp',
};

const BV_INSTANCE = {
  BV_TCP_INSTANCE: 'tcp_hosted_app',
  BV_GYM_INSTANCE: 'gym_hosted_app',
  BV_SNJ_INSTANCE: 'snj_hosted_app',
  BV_PJP_INSTANCE: 'main_implementation_pjplace_app',
};

const CATALOGID_CONFIG = {
  [TCP]: {
    USA: '10551',
    Canada: '10552',
  },
  [GYM_CMS]: {
    USA: '10555',
    Canada: '10556',
  },
  [SNJ]: {
    USA: '10551',
    Canada: '10552',
  },
  // PJP To-Do
  [PJP]: {
    USA: '10551',
    Canada: '10552',
  },
};

const APP_STORE_IDS = {
  [TCP]: {
    appID: {
      ios: '1292363109',
      android: 'com.childrensplace.tcpmobileapp',
    },
    intentUrl: 'tcp://',
  },
  [GYM]: {
    appID: {
      ios: '1495871937',
      android: 'com.childrensplace.gymmobileapp',
    },
    intentUrl: 'gym://',
  },
  [SNJ]: {
    appID: {
      ios: '1292363109',
      android: 'com.childrensplace.snjmobileapp',
    },
    intentUrl: 'snj://',
  },
  [PJP]: {
    appID: {
      ios: '1635182012',
      android: 'com.childrensplace.pjpmobileapp',
    },
    intentUrl: 'pjp://',
  },
};

const TCP_FULL_NAME = "The Children's Place";

const HEADER_CONFIG = {
  [TCP]: {
    alt: TCP_FULL_NAME,
    dataLocator: 'global_TCPlink',
    imgSrc: getStaticFilePath('images/tcp-logo.svg'),
    title: TCP_FULL_NAME,
  },
  [GYM]: {
    alt: [GYM_CMS],
    dataLocator: 'global_Gymboreelink',
    imgSrc: getStaticFilePath('images/gymboree-logo.svg'),
    title: [GYM_CMS],
  },
  [SNJ]: {
    alt: TCP_FULL_NAME,
    dataLocator: 'global_SNJlink',
    imgSrc: getStaticFilePath('images/snj-logo.svg'),
    title: TCP_FULL_NAME,
  },
  [PJP]: {
    alt: TCP_FULL_NAME,
    dataLocator: 'global_PJPlink',
    imgSrc: getStaticFilePath('images/pjp-logo.svg'),
    title: TCP_FULL_NAME,
  },
};

const DIMENSIONS = {
  [TCP]: {
    CARD_HEIGHT: 90,
    CARD_IMAGE_WIDTH: 138,
    BORDER_RADIUS: 16,
    TOP_BANNER_HEIGHT: 160,
  },
  [GYM]: {
    CARD_HEIGHT: 120,
    CARD_IMAGE_WIDTH: 172,
    BORDER_RADIUS: 16,
    TOP_BANNER_HEIGHT: 160,
  },
  [SNJ]: {
    CARD_HEIGHT: 90,
    CARD_IMAGE_WIDTH: 138,
    BORDER_RADIUS: 16,
    TOP_BANNER_HEIGHT: 160,
  },
  [PJP]: {
    CARD_HEIGHT: 90,
    CARD_IMAGE_WIDTH: 138,
    BORDER_RADIUS: 16,
    TOP_BANNER_HEIGHT: 160,
  },
};

const L1_TEXT_VIEW = {
  [TCP]: '50%',
  [GYM]: '40%',
  [SNJ]: '50%',
  [PJP]: '50%', // PJP To-Do
};

const PAYPAL_SHAPE = {
  [GYM]: 'pill',
  [TCP]: 'rounded',
  [PJP]: 'rounded', // PJP To-Do
};

const PRICE_COLOR = {
  [GYM]: 'gray.900',
  [TCP]: 'red.500',
  [SNJ]: 'red.500',
  [PJP]: 'red.500', // PJP To-Do
};

const MODULE_M_HEADER_FONT_SIZE = {
  [GYM]: 'fs20',
  [TCP]: 'fs48',
  [SNJ]: 'fs48',
  [PJP]: 'fs48', // PJP To-Do
};

const MODULE_M_HEADER_FONT_WEIGHT = {
  [GYM]: 'regular',
  [TCP]: 'bold',
  [SNJ]: 'bold',
  [PJP]: 'bold', // PJP To-Do
};

const MODULE_M_HEADER_LINE_HEIGHT = {
  [GYM]: 20,
  [TCP]: 48,
  [SNJ]: 48,
  [PJP]: 48, // PJP To-Do
};

const MODULE_M_LINK_FONT_FAMILY = {
  [GYM]: 'primary',
  [TCP]: 'tertiary',
  [SNJ]: 'tertiary',
  [PJP]: 'tertiary', // PJP To-Do
};

const MODULE_M_FONT_FAMILY = {
  [GYM]: 'primary',
  [TCP]: 'secondary',
  [PJP]: 'primary', // PJP To-Do
};

const MODULE_M_BODY_COPY_FONT_SIZE = {
  [GYM]: 'fs15',
  [TCP]: 'fs14',
  [SNJ]: 'fs14',
  [PJP]: 'fs14', // PJP To-Do
};

const MODULE_M_BODY_MARGIN_TOP = {
  [GYM]: 10,
  [TCP]: 4,
  [SNJ]: 4,
  [PJP]: 4, // PJP To-Do
};

const MODULE_N_FONT_FAMILY = {
  [GYM]: 'secondary',
  [TCP]: 'quaternary',
  [SNJ]: 'quaternary',
  [PJP]: 'quaternary', // PJP To-Do
};

const MODULE_N_FONT_SIZE = {
  [GYM]: 'fs20',
  [TCP]: 'fs32',
  [SNJ]: 'fs32',
  [PJP]: 'bold', // PJP To-Do
};

const MODULE_N_FONT_WEIGHT = {
  [GYM]: 'semibold',
  [TCP]: 'black',
  [SNJ]: 'black',
  [PJP]: 'bold', // PJP To-Do
};

const MODULE_N_IMG_DATA = {
  [TCP]: { crops: ['t_mod_N_img_m', 't_mod_N_img_t', 't_mod_N_img_d'] },
  [SNJ]: { crops: ['t_mod_N_img_m', 't_mod_N_img_t', 't_mod_N_img_d'] },
  [GYM]: { crops: ['t_mod_N_GYM_img_m', 't_mod_N_GYM_img_t', 't_mod_N_GYM_img_d'] },
  // PJP To-Do
  [PJP]: { crops: ['t_mod_N_GYM_img_m', 't_mod_N_GYM_img_t', 't_mod_N_GYM_img_d'] },
};

const MODULE_N_LETTER_SPACING = {
  [GYM]: 'ls222',
  [TCP]: 'ls167',
  [SNJ]: 'ls167',
  [PJP]: 'ls167', // PJP To-Do
};

const MODULE_S_HEIGHT = {
  [TCP]: 356,
  [GYM]: 420,
  [PJP]: 420, // PJP To-Do
};

const MODULE_S_IMG_DATA = {
  [TCP]: { crops: ['t_mod_S_TCP_img_m', 't_mod_S_GYM_img_t', 't_mod_S_TCP_img_d'] },
  [GYM]: { crops: ['t_mod_S_GYM_img_m', 't_mod_S_GYM_img_t', 't_mod_S_GYM_img_d'] },
  [PJP]: { crops: ['t_mod_S_GYM_img_m', 't_mod_S_GYM_img_t', 't_mod_S_GYM_img_d'] },
  // PJP To-Do
};

const MODULE_S_VID_DATA = {
  [TCP]: { crops: ['t_mod_S_TCP_vid_m', 't_mod_S_TCP_vid_t', 't_mod_S_TCP_vid_d'] },
  [GYM]: { crops: ['t_mod_S_GYM_vid_m', 't_mod_S_GYM_vid_t', 't_mod_S_GYM_vid_d'] },
  [PJP]: { crops: ['t_mod_S_GYM_vid_m', 't_mod_S_GYM_vid_t', 't_mod_S_GYM_vid_d'] },
  // PJP To-Do
};

const SEARCH_BAR_BODY_COLOR = {
  [GYM]: 'gray.900',
  [TCP]: 'red.500',
  [SNJ]: 'red.500',
  [PJP]: 'red.500', // PJP To-Do
};

const SIGN_UP_FORM_FONT_FAMILY = {
  [GYM]: 'primary',
  [TCP]: 'secondary',
  [SNJ]: 'secondary',
  [PJP]: 'secondary', // PJP To-Do
};

const SIGN_UP_FORM_TEXT_LABEL_CLASS = {
  [GYM]: 'know-text',
  [TCP]: 'off-text',
  [SNJ]: 'off-text',
  [PJP]: 'off-text', // PJP To-Do
};

const SIGN_UP_FORM_GETTEXT_LABEL_CLASS = {
  [GYM]: 'first-text',
  [TCP]: 'get-text',
  [SNJ]: 'get-text',
  [PJP]: 'get-text', // PJP To-Do
};

const THANKYOU_ICON_FILL_COLOUR = {
  [TCP]: blue[500],
  [GYM]: orange[800],
  [SNJ]: purple[900],
  [PJP]: pjpColorsTheme.colors.PJP_BLUE,
};

const NAVBAR_SEMICIRCLE_FILL_COLOUR = {
  [TCP]: blue[500],
  [GYM]: orange[800],
  [SNJ]: purple[900],
  [PJP]: pjpColorsTheme.colors.NAVIGATION_BAR_SEMICIRCLE,
};

const NAVBAR_SEMICIRCLE_FILL_COLOUR_HOVER = {
  [TCP]: blue[500],
  [GYM]: orange[800],
  [SNJ]: purple[900],
  [PJP]: pjpColorsTheme.colors.NAVIGATION_BAR_SEMICIRCLE_HOVER,
};

const NAVBAR_SEMICIRCLE_FILL_OPACITY = {
  [TCP]: '0.35',
  [GYM]: '0.35',
  [SNJ]: '0.35',
  [PJP]: '1',
};

const SIGN_UP_FORM_REGISTER_BUTTON = {
  [TCP]: 'BLUE',
  [GYM]: 'BLUE',
  [SNJ]: 'YELLOW',
  [PJP]: 'YELLOW', // PJP To-Do
};

const BRAND_FLAGS = {
  [TCP]: {
    label: 'children-place-checkbox',
    field: 'brandTCP',
    className: 'header__brand-tab--tcp',
  },
  [GYM]: {
    label: 'gymboree-checkbox',
    field: 'brandGYM',
    className: 'header__brand-tab-gym',
  },
  [SNJ]: {
    label: 'snj-checkbox',
    field: 'brandSNJ',
    className: 'header__brand-tab-snj',
  },
  [PJP]: {
    label: 'pjp-checkbox',
    field: 'brandPJP',
    className: 'header__brand-tab-pjp',
  },
};

const NEW_BRAND_FLAGS = {
  [TCP]: {
    label: 'children-place-checkbox',
    field: 'brandTCP',
    className: 'header__brand-tab--tcp',
  },
  [GYM]: {
    label: 'gymboree-checkbox',
    field: 'brandGYM',
    className: 'header__brand-tab-gym',
  },
};

const BRAND_BASED_BANNER_DESC_DISPLAY = {
  [TCP]: 'lbl_smart_banner_desc_tcp',
  [GYM]: 'lbl_smart_banner_desc_gym',
  [SNJ]: 'lbl_smart_banner_desc_snj',
  [PJP]: 'lbl_smart_banner_desc_pjp', // PJP To-Do
};

const BRAND_BASED_BANNER_TITLE_DISPLAY = {
  [TCP]: 'lbl_tcp',
  [GYM]: 'lbl_gym',
  [SNJ]: 'lbl_snj',
  [PJP]: 'lbl_pjp', // PJP To-Do
};

const BRAND_BASED_BANNER_ICON_DISPLAY = {
  [TCP]: 'tcp-smart-banner-icon',
  [GYM]: 'gym-smart-banner-icon',
  [SNJ]: 'snj-smart-banner-icon',
  [PJP]: 'pjp-smart-banner-icon', // PJP To-Do
};

const BRAND_BASED_EXTRA_POINTS_FONT = {
  [TCP]: 'Tofino',
  [GYM]: 'Montserrat,Arial, Helvetica, sans-serif',
  [SNJ]: 'UrbaneRounded,Arial, Helvetica, sans-serif',
  [PJP]: 'UrbaneRounded', // PJP To-Do
};

const COMPLETE_LOOK_ICON_PATH = {
  [TCP]: 'standard_clothes_3x',
  [GYM]: 'standard_clothes_3x',
  [SNJ]: 'complete-my-look',
  [PJP]: 'standard_clothes_3x',
};

const SHARE_GET_ICON_PATH = {
  [TCP]: 'share-icon-3x',
  [GYM]: 'share-icon-3x',
  [SNJ]: 'share-icon-snj',
  [PJP]: 'share-icon-3x',
};

const STORE_ADDRESS_TILE = {
  [TCP]: {
    GET_DETAILS_TILE_FOOTER_CLASSNAME: '',
    GET_DETAILS_TILE_FOOTER_FILL: 'BLUE',
    GET_FAV_LINK_FILL: '',
  },
  [GYM]: {
    GET_DETAILS_TILE_FOOTER_CLASSNAME: '',
    GET_DETAILS_TILE_FOOTER_FILL: 'BLUE',
    GET_FAV_LINK_FILL: '',
  },
  [SNJ]: {
    GET_DETAILS_TILE_FOOTER_CLASSNAME: 'button-style',
    GET_DETAILS_TILE_FOOTER_FILL: '',
    GET_FAV_LINK_FILL: 'SNJ_SECONDARY',
  },
  // PJP To-Do
  [PJP]: {
    GET_DETAILS_TILE_FOOTER_CLASSNAME: '',
    GET_DETAILS_TILE_FOOTER_FILL: 'BLUE',
    GET_FAV_LINK_FILL: '',
  },
};

const PROMOTION_UTILS = {
  [TCP]: '@tcp/core/src/assets/special-offers-tcp.png',
  [GYM]: '@tcp/core/src/assets/special-offers-gym.png',
  [SNJ]: '@tcp/core/src/assets/special-offers-snj.png',
  [PJP]: '', // PJP To-Do
};

const CHECKOUT_HEADER = {
  [TCP]: {
    TEXT_SECTION_FONT_FAMILY: 'primary',
    TEXT_SECTION_FONT_WEIGHT: 'semibold',
  },
  [GYM]: {
    TEXT_SECTION_FONT_FAMILY: 'primary',
    TEXT_SECTION_FONT_WEIGHT: 'semibold',
  },
  [SNJ]: {
    TEXT_SECTION_FONT_FAMILY: 'urbaneRounded',
    TEXT_SECTION_FONT_WEIGHT: 'demiBold',
  },
  [PJP]: {
    TEXT_SECTION_FONT_FAMILY: 'primary',
    TEXT_SECTION_FONT_WEIGHT: 'semibold',
  },
};

const MYFAV_ROUND_CIRCLE_TEXT_COLOR = {
  [TCP]: 'white',
  [GYM]: 'white',
  [SNJ]: 'black',
  [PJP]: 'white',
};

const GYMBOREE_CROSS_BRAND_FONT = {
  [TCP]: 'primary',
  [GYM]: 'primary',
  [SNJ]: 'urbaneRounded',
  [PJP]: 'primary',
};

const NAV_MENU_LEVEL_TWO = {
  [TCP]: {
    TITLE_CONTAINER_FONT_FAMILY: 'primary',
    TITLE_CONTAINER_FONT_WEIGHT: 'medium',
  },
  [GYM]: {
    TITLE_CONTAINER_FONT_FAMILY: 'primary',
    TITLE_CONTAINER_FONT_WEIGHT: 'medium',
  },
  [SNJ]: {
    TITLE_CONTAINER_FONT_FAMILY: 'urbaneRounded',
    TITLE_CONTAINER_FONT_WEIGHT: 'black',
  },
  [PJP]: {
    TITLE_CONTAINER_FONT_FAMILY: 'primary',
    TITLE_CONTAINER_FONT_WEIGHT: 'medium',
  },
};

const BUTTON_REDESIGN_PROPS_BORDER_RADIUS = {
  [TCP]: '16px',
  [GYM]: '23px',
  [SNJ]: '16px',
  [PJP]: '16px',
};

const COMBINED_CONFIRM_COLOR = {
  [TCP]: 'blue',
  [GYM]: 'orange',
  [SNJ]: 'blue',
  [PJP]: 'blue',
};

const COMBINED_FORM_INTRO = {
  [TCP]: {
    SIGN_UP_GET_TEXT: 'get-text',
    SIGN_UP_OFF_TEXT: 'off-text',
  },
  [GYM]: {
    SIGN_UP_GET_TEXT: 'first-text',
    SIGN_UP_OFF_TEXT: 'know-text',
  },
  [SNJ]: {
    SIGN_UP_GET_TEXT: 'get-text',
    SIGN_UP_OFF_TEXT: 'off-text',
  },
  [PJP]: {
    SIGN_UP_GET_TEXT: 'get-text',
    SIGN_UP_OFF_TEXT: 'off-text',
  },
};

const SMS_SIGNUP_FORM_RENDER_TAP_TO_JOIN = {
  [TCP]: 'header__brand-tab--tcp',
  [GYM]: 'gymboree-icon',
  [SNJ]: 'header__brand-tab--tcp',
  [PJP]: 'header__brand-tab--tcp',
};

const INITIALIZE_PAYPAL_BUTTON = {
  [TCP]: 'rect',
  [GYM]: 'pill',
  [SNJ]: 'rect',
  [PJP]: 'rect',
};

const GET_BUTTON_BORDER_RADIUS = {
  [TCP]: '16px',
  [GYM]: '23px',
  [SNJ]: '16px',
  [PJP]: '16px',
};

const PRODUCT_INFORMATION_NEW_DESIGN_PILL = {
  [TCP]: 'gray.900',
  [GYM]: 'red.500',
  [SNJ]: 'gray.900',
  [PJP]: 'gray.900',
};

const BUNDLE_PRICE_SECTION = {
  [TCP]: 'gray.900',
  [GYM]: 'red.500',
  [SNJ]: 'gray.900',
  [PJP]: 'gray.900',
};

const FILTERS_VIEW_BR = {
  [TCP]: '16px',
  [GYM]: '23px',
  [SNJ]: '16px',
  [PJP]: '16px',
};

const FILTERS_VIEW_FONT_FAMILY = {
  [TCP]: 'secondary',
  [GYM]: 'primary',
  [SNJ]: 'secondary',
  [PJP]: 'secondary',
};

const OUTFIT_PRODUCT_COLOR = {
  [TCP]: 'red.500',
  [GYM]: 'red.500',
  [SNJ]: 'red.500',
  [PJP]: 'red.500',
};

const CREATE_ACCOUNT_FORM_BR = {
  [TCP]: '16px',
  [GYM]: '200px',
  [SNJ]: '16px',
  [PJP]: '16px',
};

const SMS_TAP_TO_JOIN_HEIGHT = {
  [TCP]: '51px',
  [GYM]: '33px',
  [SNJ]: '51px',
  [PJP]: '51px',
};
const SMS_TAP_TO_JOIN_WIDTH = {
  [TCP]: '42px',
  [GYM]: '27px',
  [SNJ]: '42px',
  [PJP]: '42px',
};

const SMS_TAP_TO_JOIN_FONT_FAMILY = {
  [TCP]: 'primary',
  [GYM]: 'primary',
  [SNJ]: 'urbaneRounded',
  [PJP]: 'primary',
};

const SMS_TAP_TO_JOIN_COLOR = {
  [TCP]: 'blue.500',
  [GYM]: 'orange.800',
  [SNJ]: 'purple.900',
  [PJP]: 'blue.1200',
};

const SIGN_UP_CONFIRM_COLOR = {
  [TCP]: 'blue',
  [GYM]: 'orange',
  [SNJ]: 'blue',
  [PJP]: 'blue',
};

const RECOM_FBT_VIEW_SRC = {
  [TCP]: 'header__brand-tab--tcp',
  [GYM]: 'header__brand-tab-gymboree',
  [SNJ]: 'header__brand-tab--tcp',
  [PJP]: 'header__brand-tab--tcp',
};

const BODY_COPY_STYLES_COLOR = {
  [TCP]: 'text.primary',
  [GYM]: 'white',
  [SNJ]: 'text.primary',
  [PJP]: 'text.primary',
};

const BODY_COPY_STYLES_LINEHEIGHT = {
  [TCP]: 50,
  [GYM]: 47,
  [SNJ]: 50,
  [PJP]: 50,
};

const BODY_COPY_STYLES_FONT_FAMILY = {
  [TCP]: 'secondary',
  [GYM]: 'primary',
  [SNJ]: 'secondary',
  [PJP]: 'secondary',
};
const HEADER_LONGER_BRAND_IDS = {
  [TCP]: 'tcp',
  [GYM]: 'gym',
  [SNJ]: 'snj',
  [PJP]: 'pjp',
};

const FAVORITE_ICON_STROKE = {
  [TCP]: '#c8102e',
  [GYM]: '#c8102e',
  [SNJ]: '#c8102e',
  [PJP]: '#c8102e',
};
const FAVORITE_ICON_FILL = {
  [TCP]: '#c8102e',
  [GYM]: '#c8102e',
  [SNJ]: '#c8102e',
  [PJP]: '#c8102e',
};

const FAVORITES_VIEW_BUTTON_FILL = {
  [TCP]: 'BLUE',
  [GYM]: 'BLUE',
  [SNJ]: 'BLUE',
  [PJP]: 'PJP_PRIMARY',
};

const SHARE_ICON_STROKE = {
  [TCP]: '#000',
  [GYM]: '#000',
  [SNJ]: '#beb3ff',
  [PJP]: '#327f86',
};

export {
  APP_STORE_IDS,
  BRAND_CMS,
  BRAND_CONFIG_OPTION,
  BRAND_TOKEN,
  BRAND_BASED_EXTRA_POINTS_FONT,
  BV_INSTANCE,
  CAROUSAL_ICON,
  CATEGORY_CAROUSEL_IMAGE,
  CATALOGID_CONFIG,
  DIMENSIONS,
  DOWNLOAD_APP_CLICK_EVENT_DATA,
  FOOTER_CANDIDATE_A_COL_SIZE,
  FOOTER_CANDIDATE_A_REFER_FRIEND_COL_SIZE,
  FOOTER_CANDIDATE_B_COL_SIZE,
  FOOTER_CANDIDATE_B_SOCIAL_MEDIA_COL_SIZE,
  HEADER_GRAY_ICON,
  HEADER_STYLES,
  GET_CANDID_WALL_PLUGIN_CLASS,
  GUIDE_COLOR,
  GYM,
  HEADER_CONFIG,
  L1_TEXT_VIEW,
  LINK_TEXT_STYLE,
  LONGER_BRAND_IDS,
  MODULE_A,
  MODULE_D,
  MODULE_G,
  MODULE_N,
  PICKUP_SKU_SELECTION_BRAND_COLOR,
  ICON_FILL_COLOR,
  SNJ_PRIMARY_FILL_BLUE,
  SNJ_SECONDARY_FILL_WHITE,
  SNJ_HP_PRIMARY_FILL,
  PRODUCT_ADD_TO_BAG_SHOW_SIMILAR_LINK,
  PRODUCT_PRICE_BODY_COPY_COLOR,
  TCP,
  SNJ,
  PAYPAL_SHAPE,
  PRICE_COLOR,
  MODULE_M_LINK_FONT_FAMILY,
  MODULE_M_HEADER_FONT_SIZE,
  MODULE_M_HEADER_FONT_WEIGHT,
  MODULE_M_HEADER_LINE_HEIGHT,
  MODULE_M_FONT_FAMILY,
  MODULE_M_BODY_COPY_FONT_SIZE,
  MODULE_M_BODY_MARGIN_TOP,
  MODULE_N_FONT_FAMILY,
  MODULE_N_FONT_SIZE,
  MODULE_N_FONT_WEIGHT,
  MODULE_N_IMG_DATA,
  MODULE_N_LETTER_SPACING,
  MODULE_S_HEIGHT,
  MODULE_S_IMG_DATA,
  MODULE_S_VID_DATA,
  SEARCH_BAR_BODY_COLOR,
  SIGN_UP_FORM_FONT_FAMILY,
  SIGN_UP_FORM_TEXT_LABEL_CLASS,
  SIGN_UP_FORM_GETTEXT_LABEL_CLASS,
  SHOW_REFER_FRIEND,
  SHOW_SOCIAL_MEDIA_LINKS,
  SOCIAL_MEDIA_CLASS_NAME,
  SUB_HEADER_STYLES,
  COLOR_VARIATION,
  BODY_COLOR,
  SWITCH_BRAND,
  THANKYOU_ICON_FILL_COLOUR,
  TOGGLE_BRAND,
  TWITTER_SITE_TAG,
  TWITTER_SITE_CARD_TYPE,
  CANDID_TAG,
  DOMAIN,
  SIGN_UP_FORM_REGISTER_BUTTON,
  BRAND_FLAGS,
  NEW_BRAND_FLAGS,
  IMAGES_BADGE_PARAMS_PATH,
  BRAND_BASED_BANNER_DESC_DISPLAY,
  BRAND_BASED_BANNER_TITLE_DISPLAY,
  BRAND_BASED_BANNER_ICON_DISPLAY,
  APP_BRAND,
  COLOR_VARIATION_PLP,
  COMPLETE_LOOK_ICON_PATH,
  SHARE_GET_ICON_PATH,
  STORE_ADDRESS_TILE,
  PROMOTION_UTILS,
  CHECKOUT_HEADER,
  MYFAV_ROUND_CIRCLE_TEXT_COLOR,
  GYMBOREE_CROSS_BRAND_FONT,
  NAV_MENU_LEVEL_TWO,
  BUTTON_REDESIGN_PROPS_BORDER_RADIUS,
  COMBINED_CONFIRM_COLOR,
  COMBINED_FORM_INTRO,
  SMS_SIGNUP_FORM_RENDER_TAP_TO_JOIN,
  INITIALIZE_PAYPAL_BUTTON,
  GET_BUTTON_BORDER_RADIUS,
  PRODUCT_INFORMATION_NEW_DESIGN_PILL,
  BUNDLE_PRICE_SECTION,
  FILTERS_VIEW_BR,
  FILTERS_VIEW_FONT_FAMILY,
  OUTFIT_PRODUCT_COLOR,
  CREATE_ACCOUNT_FORM_BR,
  SMS_TAP_TO_JOIN_HEIGHT,
  SMS_TAP_TO_JOIN_WIDTH,
  SMS_TAP_TO_JOIN_FONT_FAMILY,
  SMS_TAP_TO_JOIN_COLOR,
  SIGN_UP_CONFIRM_COLOR,
  RECOM_FBT_VIEW_SRC,
  BODY_COPY_STYLES_COLOR,
  BODY_COPY_STYLES_LINEHEIGHT,
  BODY_COPY_STYLES_FONT_FAMILY,
  HEADER_LONGER_BRAND_IDS,
  FAVORITE_ICON_STROKE,
  FAVORITE_ICON_FILL,
  FAVORITES_VIEW_BUTTON_FILL,
  SHARE_ICON_STROKE,
  NAVBAR_SEMICIRCLE_FILL_COLOUR,
  NAVBAR_SEMICIRCLE_FILL_COLOUR_HOVER,
  NAVBAR_SEMICIRCLE_FILL_OPACITY,
};
